<template>
  <div>
    <svg
      class="clickable"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="498px"
      height="214px"
      viewBox="0 0 498 214"
      enable-background="new 0 0 498 214"
      xml:space="preserve"
      style="max-height:200px;"
    >
      <g>
        <g>
          <path
            fill="#D9D9D9"
            d="M400.351,212.624l17.577-1.105c15.777-0.989,31.131-5.906,44.214-14.778
			c23.884-16.225,33.508-40.049,34.849-75.004V94.017c-1.341-34.966-10.965-58.779-34.849-75.004
			c-13.083-8.882-28.437-13.8-44.214-14.789l-17.577-1.106c-11.377-0.717-22.79-0.505-34.132,0.636c0,0-14.014,14.356-20.835,15.798
			c-69.44,14.685-69.44,17.427-250.57,21.025C78.14,40.908,51.189,7.754,37.507,13.025c-22.66,9.789-32.861,30.166-33.131,85.11
			v19.484c0.27,54.944,10.471,75.321,33.131,85.098c13.683,5.271,40.631-27.778,57.307-27.54
			c181.13,2.599,181.13,5.341,250.57,21.024c6.799,1.536,20.835,15.787,20.835,15.787
			C377.561,213.129,388.974,213.341,400.351,212.624 M350.748,192.105l-62.168-12.178c-4.2-0.823-8.412-1.541-12.637-2.152
			c11.483-53.874,12.73-86.252,0-140.796c4.225-0.612,8.437-1.329,12.637-2.153l62.168-12.177
			c13.412-2.636,26.859,4.612,31.896,17.318c6.659,16.801,9.624,36.308,10.365,62.38l0.012,10.06
			c-0.753,26.072-3.718,45.578-10.377,62.379C377.607,187.493,364.16,194.74,350.748,192.105"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_1_"
              d="M13.458,109.615c0,37.888,9.821,68.126,25.023,77.063c1.338-0.057,2.746-0.202,4.186-0.43l24.108-3.954
				c1.071-0.174,2.08-0.539,3.005-1.087c-2.85-1.16-4.983-2.12-6.881-3.1c-7.234-3.718-12.61-10.075-15.135-17.904
				c-3.981-12.361-5.381-23.703-6.456-39.114c-0.265-3.818-0.4-7.755-0.4-11.695v-2.553c0-3.873,0.135-7.732,0.4-11.472
				c1.077-15.504,2.478-26.895,6.456-39.232c2.525-7.828,7.901-14.186,15.135-17.904c1.901-0.975,4.006-1.924,6.994-3.149
				c-0.951-0.58-1.999-0.969-3.119-1.155l-24.107-3.953c-1.334-0.219-2.703-0.36-4.067-0.419
				C21.232,39.834,13.458,77.159,13.458,109.615"
            />
          </defs>
          <clipPath id="SVGIDE_2_">
            <use xlink:href="#SVGIDE_1_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_3_"
            gradientUnits="userSpaceOnUse"
            x1="-153"
            y1="403"
            x2="-152"
            y2="403"
            gradientTransform="matrix(56.4348 0 0 -56.4348 8647.9883 22851.3438)"
          >
            <stop offset="0" style="stop-color:#172225" />
            <stop offset="0.1883" style="stop-color:#172225" />
            <stop offset="0.9456" style="stop-color:#41494A" />
            <stop offset="1" style="stop-color:#41494A" />
          </linearGradient>
        </g>
        <path
          id="bonnet"
          :style="bonnetClass"
          v-on:click="changeSeverity('bonnet')"
          d="M365.044,23.251c0,0,4.29-8.585,8.623-11.251c0,0,0.666-3.833,31.333-1c0,0,10.202,0.795,20.667,2.667
		c4.359,0.779,10.011,1.792,13,2.937C448.833,20.5,459,25.833,462,29s11.999,9.833,21.833,28c0,0,0-1-1,1.833
		c0,0,0.224,96.374,0.167,98.333l0.334,0.917c0,0-6.249,11.583-8.333,13.333c0,0-5.75,8.084-8.167,9.584
		c0,0-5.583,5.999-13.583,10.416c0,0-3.917,3.584-18.917,7.667c0,0-12.416,3.416-20.5,3.833c0,0-22.5,2.25-30.917,1.667
		c0,0-8.117,1.032-11.917-4.25c0,0-5.829-7.708-5.956-8.813c0,0,4.808-1.015,11.049-6.518c0,0,6.288-2.886,10.241-20.337
		c0,0,5.249-15.415,6.416-42.666c0,0,1.04-33.539-1.813-49.337C390.937,72.664,387.303,26.4,365.044,23.251z"
        />
        <path
          id="roof"
          :style="roofClass"
          v-on:click="changeSeverity('roof')"
          d="M74.5,46.5v121.917c0,0,47.583,0.584,81.667,1.584c0,0,23.75,0.75,51.333,2.083c0,0,59.647,3.522,68.5,5.5
		s0.167,0.25,0.167,0.25s3.33-14.419,6.623-38.418c0,0,1.804-18.19,1.938-21.593c0,0,0.347-18.473,0.041-22.491
		c0,0-0.771-10.749-1.687-19.499c0,0-6.111-35.918-7.139-38.542c0,0-51.361,5.126-80.028,5.876L74.5,46.5z"
        />
        <g>
          <path
            d="M69.495,35.058c-2.819,1.162-4.842,2.078-6.677,3.019c-7.276,3.74-12.682,10.134-15.222,18.006
			c-3.983,12.356-5.386,23.757-6.464,39.274c-0.266,3.747-0.401,7.611-0.401,11.485v2.554c0,3.94,0.135,7.88,0.401,11.707
			c1.076,15.425,2.478,26.777,6.464,39.156c2.54,7.872,7.946,14.268,15.222,18.006c1.822,0.94,3.865,1.866,6.558,2.969
			c-0.82,0.439-1.701,0.736-2.63,0.888l-24.105,3.953c-1.419,0.224-2.803,0.368-4.115,0.426c-7.86-4.644-14.333-14.82-18.723-29.436
			c-4.036-13.436-6.169-29.844-6.169-47.449c0-17.858,2.281-35.449,6.422-49.53c4.499-15.297,10.926-25.788,18.588-30.349
			c1.344,0.061,2.687,0.2,3.995,0.415l24.106,3.952C67.725,34.267,68.647,34.587,69.495,35.058 M70.274,35.12
			c-1.024-0.682-2.2-1.153-3.471-1.365l-24.107-3.953c-1.365-0.223-2.753-0.365-4.141-0.424
			c-16.534,9.73-25.274,45.143-25.274,80.237c0,33.783,8.104,67.271,25.156,77.243c1.424-0.06,2.847-0.212,4.259-0.437l24.107-3.953
			c1.236-0.199,2.365-0.646,3.365-1.294c-2.588-1.047-4.977-2.083-7.188-3.224c-7.189-3.694-12.566-10.106-15.048-17.801
			c-3.895-12.096-5.354-23.377-6.448-39.072c-0.27-3.895-0.4-7.789-0.4-11.683v-2.554c0-3.823,0.13-7.647,0.4-11.459
			c1.094-15.754,2.542-27.072,6.448-39.19c2.482-7.695,7.859-14.107,15.048-17.801C65.227,37.238,67.65,36.191,70.274,35.12"
          />
          <path
            d="M74.319,168.617l0.004-0.354c59.377,0.834,127.973,2.385,186.525,7.558c9.29,0.82,18.632,2.146,27.764,3.935
			l62.171,12.183c13.371,2.62,26.7-4.617,31.692-17.212c6.388-16.106,9.583-35.327,10.362-62.322v-10.056
			c-0.779-26.99-3.975-46.211-10.362-62.318c-4.992-12.594-18.321-19.832-31.692-17.211L288.612,35
			c-9.137,1.79-18.478,3.114-27.764,3.934c-58.55,5.174-127.146,6.724-186.525,7.558l-0.004-0.354
			c59.372-0.833,127.96-2.383,186.5-7.556c9.273-0.819,18.602-2.14,27.726-3.929l62.172-12.182
			c13.537-2.653,27.033,4.676,32.089,17.427c6.402,16.147,9.606,35.406,10.387,62.445v10.065
			c-0.78,27.043-3.984,46.302-10.387,62.449c-5.056,12.751-18.552,20.08-32.089,17.427l-62.172-12.183
			c-9.121-1.787-18.449-3.109-27.726-3.931C202.276,171,133.689,169.45,74.319,168.617"
          />
          <path
            d="M35.373,187.063c2.439,0.087,4.913-0.07,7.35-0.469l24.111-3.951c4.44-0.729,7.664-4.523,7.664-9.024V42.608
			c0-4.501-3.224-8.295-7.664-9.024l-24.111-3.951c-2.437-0.399-1.727-0.342-4.167-0.255l0.045,0.18
			c2.417-0.087,1.652,0.029,4.065,0.424l24.111,3.951c4.27,0.699,7.369,4.348,7.369,8.675v131.011c0,4.327-3.099,7.977-7.369,8.675
			l-24.111,3.951c-2.413,0.396-2.69,0.162-5.106,0.074"
          />
          <path
            d="M364.442,191.633l0.291-0.198l5.591,8.199c2.124,3.117,5.638,4.972,9.4,4.962c60.945-0.153,84.271-10.674,103.951-46.897
			V57.193c-19.68-36.223-43.006-46.744-103.951-46.897c-3.763-0.01-7.276,1.845-9.4,4.962l-5.591,8.199l-0.291-0.198l5.59-8.2
			c2.191-3.214,5.814-5.127,9.692-5.117c31.903,0.081,52.024,3.025,67.277,9.844c15.519,6.936,26.585,18.085,37.006,37.278
			l0.021,0.084v100.64l-0.021,0.039c-10.421,19.193-21.487,30.343-37.006,37.278c-15.253,6.819-35.374,9.762-67.277,9.843
			c-3.878,0.011-7.501-1.901-9.692-5.116L364.442,191.633z"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_4_"
              d="M485.025,58.533c-0.059,0.035-0.317,0.389-0.317,1.412v95.887c0,1.013,0.259,1.377,0.317,1.412
				c0.095,0.012,0.624-0.153,1.389-1.259l0.588-0.848c3.365-4.835,5.859-8.389,8.224-14.33c0-0.011,0-0.035,0.013-0.046
				c0.929-5.941,1.494-12.284,1.753-19.024v-27.72c-0.259-6.729-0.824-13.047-1.742-18.977v-0.012
				c-2.377-5.965-4.859-9.541-8.247-14.389l-0.588-0.858c-0.741-1.061-1.261-1.248-1.379-1.248
				C485.032,58.533,485.028,58.533,485.025,58.533"
            />
          </defs>
          <clipPath id="SVGIDE_5_">
            <use xlink:href="#SVGIDE_4_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_6_"
            gradientUnits="userSpaceOnUse"
            x1="-152.9995"
            y1="403"
            x2="-151.9995"
            y2="403"
            gradientTransform="matrix(12.283 0 0 -12.283 2364.001 5057.9287)"
          >
            <stop offset="0" style="stop-color:#333333" />
            <stop offset="1" style="stop-color:#000000" />
          </linearGradient>
          <rect
            x="484.708"
            y="58.533"
            clip-path="url(#SVGIDE_5_)"
            fill="url(#SVGIDE_6_)"
            width="12.283"
            height="98.723"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_7_"
              d="M485.039,58.533c-0.061,0.035-0.331,0.389-0.331,1.412v2.506c2.595,32.403,2.205,55.438,0,88.871v4.51
				c0,1.013,0.271,1.377,0.331,1.412c0.098,0.012,0.65-0.153,1.448-1.259l0.391-0.539c2.489-36.363,2.992-60.196,0.117-94.954
				l-0.508-0.711c-0.774-1.061-1.316-1.248-1.438-1.248C485.045,58.533,485.042,58.533,485.039,58.533"
            />
          </defs>
          <clipPath id="SVGIDE_8_">
            <use xlink:href="#SVGIDE_7_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_9_"
            gradientUnits="userSpaceOnUse"
            x1="-153"
            y1="403.0049"
            x2="-152"
            y2="403.0049"
            gradientTransform="matrix(0 107.1739 107.1739 0 -42704.2266 16451.918)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.5021" style="stop-color:#7F8080" />
            <stop offset="1" style="stop-color:#4A4A49" />
          </linearGradient>
          <rect
            x="484.708"
            y="58.533"
            clip-path="url(#SVGIDE_8_)"
            fill="url(#SVGIDE_9_)"
            width="5.162"
            height="98.723"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_10_"
              d="M488.836,152.732c0.813-1.138,1.578-2.243,2.303-3.356c1.995-30.91,2.381-53.078,0.201-82.667
				c-0.738-1.15-1.518-2.285-2.348-3.448C491.551,95.685,491.104,118.825,488.836,152.732"
            />
          </defs>
          <clipPath id="SVGIDE_11_">
            <use xlink:href="#SVGIDE_10_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_12_"
            gradientUnits="userSpaceOnUse"
            x1="-153"
            y1="403.002"
            x2="-152"
            y2="403.002"
            gradientTransform="matrix(0 107.4275 107.4275 0 -42802.4688 16490.5977)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.5021" style="stop-color:#7F8080" />
            <stop offset="1" style="stop-color:#4A4A49" />
          </linearGradient>
          <rect
            x="488.836"
            y="63.261"
            clip-path="url(#SVGIDE_11_)"
            fill="url(#SVGIDE_12_)"
            width="4.684"
            height="89.472"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_13_"
              d="M492.764,146.739c0.621-1.081,1.22-2.228,1.804-3.461c1.527-25.653,1.816-45.636,0.259-70.233
				c-0.593-1.29-1.2-2.467-1.828-3.586C494.898,96.849,494.555,118.128,492.764,146.739"
            />
          </defs>
          <clipPath id="SVGIDE_14_">
            <use xlink:href="#SVGIDE_13_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_15_"
            gradientUnits="userSpaceOnUse"
            x1="-153"
            y1="403.002"
            x2="-152"
            y2="403.002"
            gradientTransform="matrix(0 101.9984 101.9984 0 -40611.0195 15662.6514)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.5021" style="stop-color:#7F8080" />
            <stop offset="1" style="stop-color:#4A4A49" />
          </linearGradient>
          <rect
            x="492.764"
            y="69.459"
            clip-path="url(#SVGIDE_14_)"
            fill="url(#SVGIDE_15_)"
            width="3.62"
            height="77.28"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_16_"
              d="M489.367,108.1c0,1.812,1.025,3.279,2.293,3.279c1.266,0,2.292-1.468,2.292-3.279s-1.026-3.28-2.292-3.28
				C490.393,104.819,489.367,106.288,489.367,108.1"
            />
          </defs>
          <clipPath id="SVGIDE_17_">
            <use xlink:href="#SVGIDE_16_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_18_"
            gradientUnits="userSpaceOnUse"
            x1="-153.0005"
            y1="403"
            x2="-152.0005"
            y2="403"
            gradientTransform="matrix(4.5859 0 0 -4.5859 1191.0116 1956.2195)"
          >
            <stop offset="0" style="stop-color:#575756" />
            <stop offset="1" style="stop-color:#FFFFFF" />
          </linearGradient>
          <rect
            x="489.367"
            y="104.819"
            clip-path="url(#SVGIDE_17_)"
            fill="url(#SVGIDE_18_)"
            width="4.585"
            height="6.56"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_19_"
              d="M489.729,108.1c0,1.525,0.864,2.764,1.932,2.764c1.066,0,1.931-1.238,1.931-2.764
				c0-1.526-0.864-2.764-1.931-2.764C490.593,105.336,489.729,106.573,489.729,108.1"
            />
          </defs>
          <clipPath id="SVGIDE_20_">
            <use xlink:href="#SVGIDE_19_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_21_"
            gradientUnits="userSpaceOnUse"
            x1="-153"
            y1="403"
            x2="-152"
            y2="403"
            gradientTransform="matrix(-3.8635 0 0 3.8635 -97.5199 -1448.8843)"
          >
            <stop offset="0" style="stop-color:#9D9D9C" />
            <stop offset="1" style="stop-color:#FFFFFF" />
          </linearGradient>
          <rect
            x="489.729"
            y="105.336"
            clip-path="url(#SVGIDE_20_)"
            fill="url(#SVGIDE_21_)"
            width="3.862"
            height="5.527"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_22_"
              d="M484.496,56.851c-0.577,0.176-1.553,0.823-1.553,3.094v95.887c0,2.259,0.976,2.906,1.553,3.095
				c0.624,0.188,1.882,0.2,3.365-1.929l0.588-0.848c2.141-3.071,3.929-5.636,5.553-8.612c0.471-2.2,0.883-4.459,1.236-6.776
				c-2.366,5.964-4.86,9.529-8.236,14.376l-0.588,0.848c-0.765,1.105-1.294,1.271-1.389,1.259c-0.059-0.035-0.317-0.399-0.317-1.412
				V59.945c0-1.023,0.259-1.377,0.317-1.412c0.095-0.012,0.624,0.153,1.389,1.248l0.588,0.858c3.388,4.848,5.87,8.424,8.247,14.401
				c-0.353-2.317-0.765-4.588-1.235-6.789c-1.636-2.988-3.424-5.553-5.564-8.623l-0.588-0.847c-1.136-1.63-2.139-2.013-2.826-2.013
				C484.824,56.768,484.643,56.804,484.496,56.851"
            />
          </defs>
          <clipPath id="SVGIDE_23_">
            <use xlink:href="#SVGIDE_22_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_24_"
            gradientUnits="userSpaceOnUse"
            x1="-152.9995"
            y1="402.9941"
            x2="-151.9995"
            y2="402.9941"
            gradientTransform="matrix(12.3066 0 0 -12.3066 2365.8474 5067.436)"
          >
            <stop offset="0" style="stop-color:#7F8080" />
            <stop offset="0.0921" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#4F4F4F" />
          </linearGradient>
          <rect
            x="482.943"
            y="56.768"
            clip-path="url(#SVGIDE_23_)"
            fill="url(#SVGIDE_24_)"
            width="12.306"
            height="102.359"
          />
        </g>
        <g>
          <path
            d="M370.666,112.687c-0.772,26.697-3.923,45.679-10.211,61.545c-2.71,6.835-8.188,12.173-15.09,14.729l-56.333-11.029
			c-3.397-0.666-6.841-1.27-10.27-1.801c6.034-28.783,8.619-49.788,8.619-69.859c0.001-20.323-2.649-41.089-8.573-67.03
			c3.415-0.529,6.843-1.131,10.223-1.793l56.334-11.03c6.901,2.555,12.38,7.893,15.089,14.729c6.293,15.876,9.439,34.86,10.2,61.547
			L370.666,112.687z M373.02,112.719l-0.013-10.059c-0.74-26.072-3.706-45.579-10.364-62.38c-3.13-7.895-9.495-13.683-17.096-16.295
			l-56.968,11.153c-4.2,0.824-8.412,1.541-12.636,2.153c6.202,26.573,9.087,47.881,9.086,68.98c0,22.21-3.197,44.189-9.086,71.816
			c4.224,0.611,8.436,1.329,12.636,2.152l56.968,11.153c7.601-2.611,13.966-8.399,17.096-16.294
			C369.301,158.298,372.267,138.791,373.02,112.719"
          />
          <g opacity="0.4">
            <g>
              <defs>
                <rect
                  id="SVGIDE_25_"
                  x="275.944"
                  y="23.984"
                  width="97.074"
                  height="167.409"
                />
              </defs>
              <clipPath id="SVGIDE_26_">
                <use xlink:href="#SVGIDE_25_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDE_26_)">
                <defs>
                  <path
                    id="SVGIDE_27_"
                    d="M345.547,191.393L288.58,180.24c-4.201-0.824-8.413-1.541-12.636-2.153
							c11.482-53.874,12.729-86.252,0-140.796c4.223-0.612,8.435-1.329,12.636-2.153l56.967-11.154
							c7.602,2.612,13.966,8.401,17.095,16.295c6.66,16.801,9.624,36.308,10.366,62.38l0.011,10.06
							c-0.753,26.071-3.717,45.578-10.377,62.379C359.513,182.993,353.148,188.781,345.547,191.393"
                  />
                </defs>
                <clipPath id="SVGIDE_28_">
                  <use xlink:href="#SVGIDE_27_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDE_29_"
                  gradientUnits="userSpaceOnUse"
                  x1="-153.0005"
                  y1="403"
                  x2="-152.0005"
                  y2="403"
                  gradientTransform="matrix(0 167.4087 167.4087 0 -67141.2266 25637.541)"
                >
                  <stop offset="0" style="stop-color:#AFCACA" />
                  <stop offset="0.2552" style="stop-color:#4A7480" />
                  <stop offset="0.4979" style="stop-color:#AFCACA" />
                  <stop offset="0.7615" style="stop-color:#4A7480" />
                  <stop offset="1" style="stop-color:#AFCACA" />
                </linearGradient>
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_30_"
              d="M350.748,22.961l-5.2,1.024c7.6,2.612,13.965,8.4,17.094,16.294c6.659,16.802,9.624,36.308,10.366,62.38
				l0.011,10.06c-0.753,26.072-3.718,45.578-10.377,62.379c-3.129,7.896-9.494,13.684-17.094,16.295l5.2,1.024
				c13.412,2.635,26.86-4.612,31.895-17.319c6.66-16.801,9.625-36.307,10.377-62.379l-0.012-10.06
				c-0.74-26.072-3.705-45.578-10.365-62.38c-4.343-10.958-14.942-17.856-26.38-17.856
				C354.438,22.423,352.593,22.598,350.748,22.961"
            />
          </defs>
          <clipPath id="SVGIDE_31_">
            <use xlink:href="#SVGIDE_30_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDE_32_"
            cx="-153"
            cy="403"
            r="1"
            gradientTransform="matrix(0 116.3652 89.353 0 -35704.4883 17911.0996)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#252525" />
            <stop offset="0.7866" style="stop-color:#252525" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
        </g>
        <g>
          <polygon
            points="369.308,162.299 374.136,163.078 386.523,135.431 393.021,113.702 393.009,102.659 384.768,134.719
			372.564,161.354 369.69,160.901 		"
          />
          <polygon
            points="373.353,94.283 377.848,93.68 381.904,73.116 378.53,33.856 374.822,29.28 380.148,72.404 376.276,91.958
			373.402,92.426 		"
          />
          <polygon
            points="371.832,119.879 371.832,92.097 371.832,64.313 372.694,64.313 374.207,92.097 372.694,119.879 		"
          />
          <polygon
            points="360.808,188.069 367.465,161.097 374.122,134.124 374.96,134.331 369.771,161.666 361.645,188.276 		"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_33_"
              d="M350.748,22.961l-5.2,1.024L288.58,35.138c-3.954,0.776-7.917,1.457-11.891,2.044
				c2.742,10.188,4.626,21.4,5.867,34.773c3.563,25.588,3.181,47.528-0.53,73.029c-1.319,11.091-3.132,20.764-5.324,29.503
				c-0.247,1.188-0.5,2.39-0.758,3.6c4.223,0.611,8.435,1.33,12.636,2.153l56.968,11.152l5.2,1.024
				c3.28,0.645,6.564,0.698,9.724,0.225c7.274-19.999,15.351-50.176,15.013-87.289c-0.321-34.833-7.963-63.257-14.986-82.612
				c-1.392-0.21-2.807-0.317-4.236-0.318C354.438,22.422,352.593,22.598,350.748,22.961"
            />
          </defs>
          <clipPath id="SVGIDE_34_">
            <use xlink:href="#SVGIDE_33_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_35_"
            gradientUnits="userSpaceOnUse"
            x1="-153"
            y1="402.998"
            x2="-152"
            y2="402.998"
            gradientTransform="matrix(100.6462 0 0 -100.6462 15673.6934 40668)"
          >
            <stop offset="0" style="stop-color:#000000" />
            <stop offset="0.682" style="stop-color:#343333" />
            <stop offset="1" style="stop-color:#000000" />
          </linearGradient>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_36_"
              d="M288.58,35.138c-3.954,0.776-7.917,1.457-11.891,2.044c2.742,10.188,4.626,21.4,5.867,34.773
				c1.254,9.007,2.02,17.563,2.322,25.981c9.239-0.75,16.478-7.227,16.478-15.094V41.421c0-4.272-0.346-6.412-2.8-8.237
				L288.58,35.138z"
            />
          </defs>
          <clipPath id="SVGIDE_37_">
            <use xlink:href="#SVGIDE_36_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_38_"
            gradientUnits="userSpaceOnUse"
            x1="-153"
            y1="402.9941"
            x2="-152"
            y2="402.9941"
            gradientTransform="matrix(0 -66.8041 -66.8041 0 27210.6992 -10123.0713)"
          >
            <stop offset="0" style="stop-color:#2E2D2C" />
            <stop offset="0.4979" style="stop-color:#3C3C3B" />
            <stop offset="0.7592" style="stop-color:#393938" />
            <stop offset="0.9845" style="stop-color:#2F2E2D" />
            <stop offset="1" style="stop-color:#2E2D2C" />
          </linearGradient>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_39_"
              d="M350.748,22.961l-5.2,1.024L288.58,35.138c-4.201,0.824-8.413,1.541-12.636,2.153
				c12.729,54.544,11.482,86.922,0,140.796c4.223,0.611,8.435,1.33,12.636,2.153l56.968,11.152l5.2,1.024
				c13.412,2.635,26.86-4.612,31.895-17.319c6.66-16.801,9.625-36.307,10.377-62.379l-0.012-10.06
				c-0.74-26.072-3.705-45.578-10.365-62.38c-4.343-10.958-14.942-17.856-26.38-17.856
				C354.438,22.423,352.593,22.598,350.748,22.961"
            />
          </defs>
          <clipPath id="SVGIDE_40_">
            <use xlink:href="#SVGIDE_39_" overflow="visible" />
          </clipPath>
          <g clip-path="url(#SVGIDE_40_)">
            <g>
              <defs>
                <rect
                  id="SVGIDE_41_"
                  x="275.944"
                  y="31.18"
                  width="25.412"
                  height="66.804"
                />
              </defs>
              <clipPath id="SVGIDE_42_">
                <use xlink:href="#SVGIDE_41_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDE_42_)">
                <defs>
                  <path
                    id="SVGIDE_43_"
                    d="M301.356,41.421v41.421c0,8.08-7.634,14.692-17.229,15.142c-0.949-27.305-3.331-46.691-8.184-63.47
							c2.724-0.387,5.411-0.837,8.042-1.331c3.234-0.612,7.422-1.4,10.853-2.003C300.706,33.708,301.356,35.555,301.356,41.421"
                  />
                </defs>
                <clipPath id="SVGIDE_44_">
                  <use xlink:href="#SVGIDE_43_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDE_45_"
                  gradientUnits="userSpaceOnUse"
                  x1="-153"
                  y1="403"
                  x2="-152"
                  y2="403"
                  gradientTransform="matrix(25.4122 0 0 -25.4122 4164.0083 10305.6875)"
                >
                  <stop offset="0" style="stop-color:#2E2D2C" />
                  <stop offset="0.1" style="stop-color:#2E2D2C" />
                  <stop offset="1" style="stop-color:#B3B3B2" />
                </linearGradient>
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_46_"
              d="M282.026,144.984c-1.319,11.091-3.132,20.764-5.324,29.503c-0.247,1.188-0.5,2.39-0.758,3.6
				c4.223,0.611,8.435,1.33,12.636,2.153l9.41,1.842c2.224-1.523,3.366-2.866,3.366-6.338v-41.422
				c0-7.947-7.348-14.464-16.683-15.132C284.217,127.56,283.326,136.05,282.026,144.984"
            />
          </defs>
          <clipPath id="SVGIDE_47_">
            <use xlink:href="#SVGIDE_46_" overflow="visible" />
          </clipPath>

          <linearGradient
            id="SVGIDE_48_"
            gradientUnits="userSpaceOnUse"
            x1="-153"
            y1="402.9902"
            x2="-152"
            y2="402.9902"
            gradientTransform="matrix(0 -64.8923 -64.8923 0 26439.6523 -9744.458)"
          >
            <stop offset="0" style="stop-color:#2E2D2C" />
            <stop offset="0.4979" style="stop-color:#3C3C3B" />
            <stop offset="0.7592" style="stop-color:#393938" />
            <stop offset="0.9845" style="stop-color:#2F2E2D" />
            <stop offset="1" style="stop-color:#2E2D2C" />
          </linearGradient>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_49_"
              d="M350.748,22.961l-5.2,1.024L288.58,35.138c-4.201,0.824-8.413,1.541-12.636,2.153
				c12.729,54.544,11.482,86.922,0,140.796c4.223,0.611,8.435,1.33,12.636,2.153l56.968,11.152l5.2,1.024
				c13.412,2.635,26.86-4.612,31.895-17.319c6.66-16.801,9.625-36.307,10.377-62.379l-0.012-10.06
				c-0.74-26.072-3.705-45.578-10.365-62.38c-4.343-10.958-14.942-17.856-26.38-17.856
				C354.438,22.423,352.593,22.598,350.748,22.961"
            />
          </defs>
          <clipPath id="SVGIDE_50_">
            <use xlink:href="#SVGIDE_49_" overflow="visible" />
          </clipPath>
          <g clip-path="url(#SVGIDE_50_)">
            <g>
              <defs>
                <rect
                  id="SVGIDE_51_"
                  x="274.848"
                  y="119.153"
                  width="26.509"
                  height="64.893"
                />
              </defs>
              <clipPath id="SVGIDE_52_">
                <use xlink:href="#SVGIDE_51_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDE_52_)">
                <defs>
                  <path
                    id="SVGIDE_53_"
                    d="M301.356,134.322v41.421c0,4.805-2.187,5.532-6.397,8.303c-4.473-0.773-8.404-2.083-12.569-2.856
							c-1.628-0.307-3.962,0.765-7.542,0.172c4.724-16.349,8.08-35.848,9.196-62.208
							C293.676,119.567,301.356,126.198,301.356,134.322"
                  />
                </defs>
                <clipPath id="SVGIDE_54_">
                  <use xlink:href="#SVGIDE_53_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDE_55_"
                  gradientUnits="userSpaceOnUse"
                  x1="-153.0005"
                  y1="403"
                  x2="-152.0005"
                  y2="403"
                  gradientTransform="matrix(26.5078 0 0 -26.5078 4330.5342 10834.2373)"
                >
                  <stop offset="0" style="stop-color:#2E2D2C" />
                  <stop offset="0.1004" style="stop-color:#2E2D2C" />
                  <stop offset="1" style="stop-color:#B3B3B2" />
                </linearGradient>
                <rect
                  x="274.848"
                  y="119.153"
                  clip-path="url(#SVGIDE_54_)"
                  fill="url(#SVGIDE_55_)"
                  width="26.508"
                  height="64.893"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_56_"
              d="M307.757,42.143c-0.28,0.327-0.937,0.391-1.289,0.851c-0.354,0.46-0.457,1.072-0.595,1.614
				c-0.347,1.36-0.493,2.771-0.64,4.162c-0.549,5.2-0.689,10.45-0.676,15.675v0.046c-0.014,5.45,0.174,10.91,0.744,16.333
				c0.136,1.276,0.297,2.583,0.646,3.824c0.146,0.523,0.299,1.191,0.698,1.591c0.288,0.289,0.914,0.326,1.11,0.553h0.059
				c0,0,0.116-0.029,0.354-0.087c0.189-0.043,0.418-0.087,0.713-0.42c0.296-0.304,0.646-1.065,0.907-2.344
				c0.13-0.56,0.266-1.481,0.341-1.988c0.05-0.397,0.104-0.823,0.159-1.276c0.404-3.62,0.717-9.014,0.724-16.209h-0.618h-0.619
				h-1.109c-0.007,7.122-0.32,12.464-0.71,15.962c-0.113,0.903-0.17,1.355-0.17,1.355c-0.22-1.696-0.385-3.396-0.502-5.101
				c-0.281-4.056-0.39-8.128-0.378-12.193v-0.046c-0.012-3.896,0.092-7.798,0.344-11.687c0.121-1.874,0.293-3.743,0.536-5.606
				c0,0,0.057,0.452,0.17,1.354c0.39,3.498,0.703,8.839,0.71,15.962h1.109h0.619h0.618c-0.007-7.195-0.319-12.589-0.724-16.208
				c-0.056-0.454-0.109-0.88-0.159-1.277c-0.075-0.507-0.211-1.428-0.341-1.989c-0.261-1.278-0.611-2.039-0.907-2.343
				c-0.295-0.333-0.523-0.377-0.713-0.42c-0.237-0.058-0.354-0.088-0.354-0.088H307.757z"
            />
          </defs>
          <clipPath id="SVGIDE_57_">
            <use xlink:href="#SVGIDE_56_" overflow="visible" />
          </clipPath>
          <g clip-path="url(#SVGIDE_57_)">
            <g>
              <defs>
                <rect
                  id="SVGIDE_58_"
                  x="304.544"
                  y="42.143"
                  width="6.469"
                  height="44.649"
                />
              </defs>
              <clipPath id="SVGIDE_59_">
                <use xlink:href="#SVGIDE_58_" overflow="visible" />
              </clipPath>
              <g
                transform="matrix(1 0 0 1 -1.210149e-005 7.667913e-007)"
                clip-path="url(#SVGIDE_59_)"
              >
                <image
                  overflow="visible"
                  width="14"
                  height="94"
                  xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA
EAMCAwYAAAG6AAACJAAAAzn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX
Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa
JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAGAAEQMBIgACEQEDEQH/
xACPAAEAAgMBAQAAAAAAAAAAAAAAAgcBAwQFBgEBAAAAAAAAAAAAAAAAAAAAABAAAQQCAgMBAAAA
AAAAAAAAAwABAgYEBTA2ERMHEhEAAgEBBQQGCQUAAAAAAAAAAQIDEQAQIRIEMUFRwWGBkbEiE3Gh
0TJCchQkdGKCsoQFEgEAAAAAAAAAAAAAAAAAAAAw/9oADAMBAAIRAxEAAADvx5UCygVpiXOWkCs4
7YllgrSMtZZ4K0074FmgrvH0494H/9oACAECAAEFAOT/2gAIAQMAAQUA5P/aAAgBAQABBQC/bMoR
0DZkKNXokjbyiG9e9Vif322uvHHtiz/zk3PAkQFtRO6v3VMJy3ognHdlOUo3d3d7sid2jKM7mtxK
ULjqhsW3K0+AWqqzjk2dfQAvHa/PwPLcK1V+e5xqpoCabFX/2gAIAQICBj8AT//aAAgBAwIGPwBP
/9oACAEBAQY/ANPoIZGj80GSbKSKoMFGHSDbUf50rlvKpJDWpOVto7bvJUkskaIAdlW8WHbZUYmk
sLpQbMwKkV9d2R9hnhjNOFVW0UUa+AyyxgcBRjyuCmoA1ajrjNeVo/hddW6kHdXMp77v7rd5s/5z
fyN2QGn3chr8uZuVmBNc2sLD0Ma3ZlND9YwqOkkGz1NfvmHYTcfzG7zZmU1VtcxBHzG5WQ5T9VFi
OllBtEjGgOqkOH6Qzcri6YFZIJMePha0UzrixlkA4Eg+26N90sIINN6krt6rPJuigIOG9yKY/tuj
bTlV1UBJQtgGU7VNpDqSraqdqvkNVCj3VBwu/9k="
                  transform="matrix(0.48 0 0 0.48 304.5439 42.1431)"
                ></image>
              </g>
            </g>
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_60_"
              d="M350.748,22.961l-5.2,1.024L288.58,35.138c-4.201,0.824-8.413,1.541-12.636,2.153
				c12.729,54.544,11.482,86.922,0,140.796c4.223,0.611,8.435,1.33,12.636,2.153l56.968,11.152l5.2,1.024
				c13.412,2.635,26.86-4.612,31.895-17.319c6.66-16.801,9.625-36.307,10.377-62.379l-0.012-10.06
				c-0.74-26.072-3.705-45.578-10.365-62.38c-4.343-10.958-14.942-17.856-26.38-17.856
				C354.438,22.423,352.593,22.598,350.748,22.961"
            />
          </defs>
          <clipPath id="SVGIDE_61_">
            <use xlink:href="#SVGIDE_60_" overflow="visible" />
          </clipPath>
          <path
            clip-path="url(#SVGIDE_61_)"
            fill="#0D0D0D"
            d="M308.658,64.638c0,5.723-0.211,10.447-0.516,13.899l-0.657,0.635
			c-0.329-3.497-0.587-8.47-0.587-14.534c0-6.245,0.223-11.332,0.574-14.875l0.667,0.452
			C308.468,53.735,308.658,58.62,308.658,64.638"
          />
          <path
            clip-path="url(#SVGIDE_61_)"
            fill="#0D0D0D"
            d="M316.872,57.013l0.619,16.284l-6.839,3.23
			c0.165-2.953,0.353-6.7,0.353-11.469c0-5.428-0.141-9.538-0.353-12.65L316.872,57.013z"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_62_"
              d="M350.748,22.961l-5.2,1.024l-29.216,5.719c1.775,25.272,2.3,49.654,2.281,78.452
				c-0.039,28.849-0.013,52.124-1.87,77.598h0.002c0.288-1.618,2.524-0.652,6.237,1.221l22.565,4.418l5.2,1.024
				c4.15,0.816,8.305,0.684,12.212-0.262c4.544-7.071,5.158-11.148,6.899-18.029c4.105-17.624,7.746-40.226,8.019-66.576v-0.038
				v-0.019c-0.137-13.175-1.11-25.403-2.57-36.553s-3.387-21.221-5.448-30.023c-1.678-6.648-0.468-10.395-4.379-16.96
				c-2.932-1.002-6.043-1.534-9.219-1.535C354.438,22.422,352.593,22.598,350.748,22.961"
            />
          </defs>
          <clipPath id="SVGIDE_63_">
            <use xlink:href="#SVGIDE_62_" overflow="visible" />
          </clipPath>

          <radialGradient
            id="SVGIDE_64_"
            cx="-153"
            cy="403"
            r="1"
            gradientTransform="matrix(67.8917 0 0 -197.0921 10700.3203 79530.9844)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#363636" />
            <stop offset="0.5607" style="stop-color:#363636" />
            <stop offset="0.5905" style="stop-color:#303030" />
            <stop offset="0.7489" style="stop-color:#161616" />
            <stop offset="0.8903" style="stop-color:#060606" />
            <stop offset="1" style="stop-color:#000000" />
          </radialGradient>
        </g>
        <g>
          <defs>
            <path
              id="SVGIDE_65_"
              d="M350.748,22.961l-5.2,1.024L288.58,35.138c-4.201,0.824-8.413,1.541-12.636,2.153
				c12.729,54.544,11.482,86.922,0,140.796c4.223,0.611,8.435,1.33,12.636,2.153l56.968,11.152l5.2,1.024
				c13.412,2.635,26.86-4.612,31.895-17.319c6.66-16.801,9.625-36.307,10.377-62.379l-0.012-10.06
				c-0.74-26.072-3.705-45.578-10.365-62.38c-4.343-10.958-14.942-17.856-26.38-17.856
				C354.438,22.423,352.593,22.598,350.748,22.961"
            />
          </defs>
          <clipPath id="SVGIDE_66_">
            <use xlink:href="#SVGIDE_65_" overflow="visible" />
          </clipPath>
          <g clip-path="url(#SVGIDE_66_)">
            <g>
              <defs>
                <rect
                  id="SVGIDE_67_"
                  x="314.955"
                  y="19.489"
                  width="62.922"
                  height="176.227"
                />
              </defs>
              <clipPath id="SVGIDE_68_">
                <use xlink:href="#SVGIDE_67_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDE_68_)">
                <defs>
                  <path
                    id="SVGIDE_69_"
                    d="M377.877,107.493v0.019v0.038c-0.271,26.351-3.912,48.952-8.018,66.575
							c-1.771,7.004-2.377,11.103-7.146,18.41c-0.798,1.211-1.79,2.233-2.958,3.048c-24.542,1.695-44.801-13.409-44.801-7.195
							c1.887-25.631,3.619-51.231,3.658-80.232c0.019-29.795-0.543-54.866-2.471-81.083c-0.019-0.303,23.285-4.649,45.279-7.583
							c1.323,0.871,2.471,1.988,3.347,3.332c4.769,7.288,3.319,11.074,5.091,18.097c2.063,8.802,3.989,18.872,5.448,30.022
							C376.768,82.09,377.741,94.318,377.877,107.493"
                  />
                </defs>
                <clipPath id="SVGIDE_70_">
                  <use xlink:href="#SVGIDE_69_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDE_71_"
                  gradientUnits="userSpaceOnUse"
                  x1="-152.9995"
                  y1="402.9883"
                  x2="-151.9995"
                  y2="402.9883"
                  gradientTransform="matrix(62.9225 0 0 -61.1994 9942.1045 24770.9727)"
                >
                  <stop offset="0" style="stop-color:#1A1A1A" />
                  <stop offset="1" style="stop-color:#FFFFFF" />
                </linearGradient>
                <rect
                  x="314.955"
                  y="19.489"
                  clip-path="url(#SVGIDE_70_)"
                  fill="url(#SVGIDE_71_)"
                  width="62.922"
                  height="177.789"
                />
              </g>
            </g>
          </g>
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter"
              filterUnits="userSpaceOnUse"
              x="313.667"
              y="30.671"
              width="42.413"
              height="81.225"
            >
              <feColorMatrix
                type="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
              />
            </filter>
          </defs>
          <mask
            maskUnits="userSpaceOnUse"
            x="313.667"
            y="30.671"
            width="42.413"
            height="81.225"
            id="SVGIDE_72_"
          >
            <g filter="url(#Adobe_OpacityMaskFilter)">
              <g>
                <defs>
                  <rect
                    id="SVGIDE_73_"
                    x="316.143"
                    y="32.313"
                    width="36.791"
                    height="78.483"
                  />
                </defs>
                <clipPath id="SVGIDE_74_" clip-path="url(#SVGIDE_66_)">
                  <use xlink:href="#SVGIDE_73_" overflow="visible" />
                </clipPath>
                <rect
                  x="316.143"
                  y="31.767"
                  clip-path="url(#SVGIDE_74_)"
                  width="37.461"
                  height="79.033"
                />
                <g enable-background="new    ">
                  <g>
                    <defs>
                      <path
                        id="SVGIDE_75_"
                        d="M352.911,70.542c0.692,21.673-13.933,39.686-32.622,40.245c-0.422,0.013-1.227,0.013-1.651-0.009
									l-2.495-78.412c0.42-0.047,1.214-0.027,1.636-0.04C336.469,31.767,352.217,48.868,352.911,70.542"
                      />
                    </defs>
                    <clipPath id="SVGIDE_76_" clip-path="url(#SVGIDE_74_)">
                      <use xlink:href="#SVGIDE_75_" overflow="visible" />
                    </clipPath>

                    <radialGradient
                      id="SVGIDE_77_"
                      cx="-153"
                      cy="403"
                      r="1"
                      gradientTransform="matrix(24.8225 0.0101 -0.1555 -35.7464 4184.666 14478.1143)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0" style="stop-color:#FFFFFF" />
                      <stop offset="0.8452" style="stop-color:#FFFFFF" />
                      <stop offset="1" style="stop-color:#000000" />
                    </radialGradient>
                    <polygon
                      clip-path="url(#SVGIDE_76_)"
                      fill="url(#SVGIDE_77_)"
                      points="315.799,31.751 353.604,31.767 353.948,110.815
								316.143,110.8 							"
                    />
                  </g>
                </g>
              </g>
            </g>
          </mask>
          <g clip-path="url(#SVGIDE_66_)" mask="url(#SVGIDE_72_)">
            <g>
              <defs>
                <rect
                  id="SVGIDE_78_"
                  x="316.143"
                  y="32.313"
                  width="36.791"
                  height="78.483"
                />
              </defs>
              <clipPath id="SVGIDE_79_">
                <use xlink:href="#SVGIDE_78_" overflow="visible" />
              </clipPath>
              <g clip-path="url(#SVGIDE_79_)">
                <defs>
                  <path
                    id="SVGIDE_80_"
                    d="M352.911,70.542c0.692,21.673-13.931,39.685-32.622,40.245c-0.422,0.013-1.227,0.013-1.65-0.008
							l-2.496-78.413c0.422-0.047,1.215-0.027,1.637-0.04C336.469,31.766,352.217,48.868,352.911,70.542"
                  />
                </defs>
                <clipPath id="SVGIDE_81_">
                  <use xlink:href="#SVGIDE_80_" overflow="visible" />
                </clipPath>

                <linearGradient
                  id="SVGIDE_82_"
                  gradientUnits="userSpaceOnUse"
                  x1="-153"
                  y1="402.9941"
                  x2="-152"
                  y2="402.9941"
                  gradientTransform="matrix(35.5377 -1.04 -1.1686 -37.2621 6225.606 14929.0957)"
                >
                  <stop offset="0" style="stop-color:#363636" />
                  <stop offset="0.5774" style="stop-color:#363636" />
                  <stop offset="0.6904" style="stop-color:#444444" />
                  <stop offset="0.8647" style="stop-color:#545454" />
                  <stop offset="1" style="stop-color:#5A5A59" />
                </linearGradient>
              </g>
              <g clip-path="url(#SVGIDE_79_)">
                <g>
                  <defs>
                    <rect
                      id="SVGIDE_83_"
                      x="316.143"
                      y="32.313"
                      width="36.791"
                      height="78.483"
                    />
                  </defs>
                  <clipPath id="SVGIDE_84_">
                    <use xlink:href="#SVGIDE_83_" overflow="visible" />
                  </clipPath>
                  <g clip-path="url(#SVGIDE_84_)">
                    <defs>
                      <path
                        id="SVGIDE_85_"
                        d="M352.911,70.542c0.692,21.673-13.931,39.685-32.622,40.245c-0.422,0.013-1.227,0.013-1.65-0.008
									l-2.496-78.413c0.422-0.047,1.215-0.027,1.637-0.04C336.469,31.766,352.217,48.868,352.911,70.542"
                      />
                    </defs>
                    <clipPath id="SVGIDE_86_">
                      <use xlink:href="#SVGIDE_85_" overflow="visible" />
                    </clipPath>

                    <radialGradient
                      id="SVGIDE_87_"
                      cx="-153"
                      cy="403"
                      r="1"
                      gradientTransform="matrix(29.4642 0.012 -0.135 -30.8896 4897.0581 12521.877)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0" style="stop-color:#FFFFFF" />
                      <stop offset="1" style="stop-color:#333333" />
                    </radialGradient>
                    <polygon
                      clip-path="url(#SVGIDE_86_)"
                      fill="url(#SVGIDE_87_)"
                      points="315.798,31.75 353.604,31.766 353.949,110.815
								316.143,110.8 							"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          opacity="0.25"
          id="frontWindscreen"
          :style="frontWindscreenClass"
          v-on:click="changeSeverity('frontWindscreen')"
          stroke-miterlimit="10"
          d="M275.944,37.291c0,0,70.223-13.958,77.223-15.291
		s16.39,2.784,17,3.333s3.978,2.526,5.655,4.18s6.011,6.32,8.178,13.32s2.833,8.5,4.5,15.833s1.667,9,3,17.833
		s1.501,21.093,1.511,28.5s0.489,15-0.511,21s-0.076,18.144-6.538,39.488s-12.179,20.424-16.131,24.025c0,0-8.51,4.157-12.254,3.405
		c0,0-3.119,0.153-5.438-0.266c0,0-72.583-14.479-76.194-14.566c0,0,10.875-40.392,8.799-83.322
		C284.743,94.765,282.222,59.582,275.944,37.291z"
        />
      </g>
      <g id="Layer_2"></g>
      <path
        id="rearWindscreen"
        :style="rearWindscreenClass"
        v-on:click="changeSeverity('rearWindscreen')"
        stroke-miterlimit="10"
        d="M13.294,109.656c0,37.889,9.821,68.127,25.023,77.064
	c1.338-0.057,2.746-0.203,4.186-0.43l24.108-3.955c1.071-0.174,2.08-0.539,3.005-1.086c-2.85-1.16-4.983-2.121-6.881-3.1
	c-7.234-3.719-12.61-10.076-15.135-17.904c-3.981-12.361-5.381-23.703-6.456-39.115c-0.265-3.818-0.4-7.754-0.4-11.695v-2.553
	c0-3.873,0.135-7.732,0.4-11.472c1.077-15.504,2.478-26.895,6.456-39.232c2.525-7.828,7.901-14.186,15.135-17.904
	c1.901-0.975,4.006-1.924,6.994-3.149c-0.951-0.58-1.999-0.969-3.119-1.155l-24.107-3.953c-1.334-0.219-2.703-0.36-4.067-0.419
	C21.068,39.875,13.294,77.2,13.294,109.656"
      />
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    rearWindscreen: Number,
    roof: Number,
    frontWindscreen: Number,
    bonnet: Number
  },

  data() {
    return {
      top: {
        rearWindscreen: 0,
        roof: 0,
        frontWindscreen: 0,
        bonnet: 0
      }
    };
  },

  computed: {
    rearWindscreenClass() {
      return this.getSeverityColour(this.top.rearWindscreen, '#3A3A3A', 0.9);
    },

    roofClass() {
      return this.getSeverityColour(this.top.roof);
    },

    frontWindscreenClass() {
      return this.getSeverityColour(this.top.frontWindscreen, '#333', 0.9);
    },

    bonnetClass() {
      return this.getSeverityColour(this.top.bonnet);
    }
  },

  methods: {
    changeSeverity(section) {
      if (this.top[section] == 3) {
        this.top[section] = 0;
      } else {
        this.top[section] = this.top[section] + 1;
      }

      this.$emit('updated', this.top);
    },

    getSeverityColour(severity, defaultColour = '#D9D9D9', opacity = null) {
      const colour = this.getColour(severity, defaultColour);

      if (opacity) {
        return {
          opacity,
          ...colour
        };
      }

      return colour;
    },

    getColour(severity, defaultColour = '#D9D9D9') {
      switch (severity) {
        case 1:
          return {
            fill: '#FFCA28'
          };

        case 2:
          return {
            fill: '#f0ad4e'
          };

        case 3:
          return {
            fill: '#d9534f'
          };

        default:
          return typeof defaultColour === 'string'
            ? {
                fill: defaultColour
              }
            : defaultColour;
      }
    }
  },

  watch: {
    rearWindscreen(value) {
      this.top.rearWindscreen = value;
    },

    roof(value) {
      this.top.roof = value;
    },

    frontWindscreen(value) {
      this.top.frontWindscreen = value;
    },

    bonnet(value) {
      this.top.bonnet = value;
    }
  }
};
</script>
